export interface IYeahState{
    PreviewSection: IPreviewSectionYeah;
    ProjectInfoSection: IProjectInfoSectionYeah;
    SolutionSection: ISolutionSectionYeah;
    FeaturesSection: IFeaturesSectionYeah;
    AccordionSection: IAccordionSectionYeah;
    ProductSection: IProductSectionYeah;
    FilterSection: IFilterSectionYeah;
    ShoppingBagSection: IShoppingBagSectionYeah;
}

export interface IPreviewSectionYeah{
    title: string;
    subtitle: string;
    image: string;
    alt: string;
    text: Array<string>;
}

export interface IProjectInfoSectionYeah{
    title: string;
    aboutProject: Array<IAboutProjectYeah>;
}

export interface IAboutProjectYeah{
    title: string;
    subtitle: string;
}

export interface ISolutionSectionYeah{
    title: string;
    text: Array<string>;
}

export interface IFeaturesSectionYeah{
    title: string;
    text: Array<string>;
}

export interface IAccordionSectionYeah{
    title: string;
    accordionItems: Array<IAccordionItemYeah>;
}

export interface IAccordionItemYeah{
    id: number;
    name: string;
    text: Array<string>;
}

export interface IProductSectionYeah{
    title: string;
    subtitle: string;
    image: string;
    alt: string;
    items: Array<IProductItemYeah>;
}

export interface IProductItemYeah{
    icon: string;
    title: string;
    subtitle: string;
    width: number;
    height: number;
}

export interface IFilterSectionYeah{
    title: string;
    subtitle: string;
    image: string;
    alt: string;
}

export interface IShoppingBagSectionYeah{
    title: string;
    subtitle: string;
    image: string; 
    alt: string;
}

export const YeahState = {
    PreviewSection: {
        title: 'YEAH',
        subtitle: 'Online men’s fashion store',
        image: '/yeah-images/preview.png',
        alt: '',
        text: [
            `YEAH is a men's fashion business online store that sells quality male underwear. When creating products, the company owners are focused on the style, streetwear, fashion, and parties. Their motto is “for the love of the party”.`,
            `Brand collections are inspired by the coloring of sunny Madrid streets and their irrepressible adventurous rhythm. And that's why the products' colors are so strong: expressive gray, the contrast of black and white, the rich palette of a fun party.`
        ]
    },
    ProjectInfoSection: {
        title: 'Project info',
        aboutProject: [
            {
                title: 'Project:',
                subtitle: 'Online fashion store'
            },
            {
                title: 'Product:',
                subtitle: 'Web app'
            },
            {
                title: 'Category:',
                subtitle: 'E-commerce'
            },
            {
                title: 'Project timeline:',
                subtitle: '6 months'
            },
        ]
    },
    SolutionSection: {
        title: 'Our solution',
        text: [
            'Our client knew how to create a fashion brand but had no idea about the pitfalls of web development.',
            `He wanted to get a cost-efficient solution for the online store. So we had a task to find the optimal technology which would allow creating an e-commerce platform with the necessary functionalities and without extra development costs. We've selected Spree Commerce since we knew by experience it would be the most preferred choice for e-commerce brands.`
        ]
    },
    FeaturesSection: {
        title: 'Features',
        text: [
            `Our goal was to make an online store that will be at the same time look professional and attractive for users, and simple and profitable for owners. And that's what we did in this case.`
        ]
    },
    AccordionSection: {
        title: 'Development Challenges to Overcome',
        accordionItems: [
            {
                id: 1,
                name: 'Ergonomic Content Management System',
                text: [
                    `CMS is the administrative panel intended to manage the content of your website. So, it’s a tool with which the client must constantly work. Therefore, this platform should be easy to use and have a clear interface. We decided to choose Spree Commerce for online store's purposes since it could provide us with such a result.`,
                ]
            },
            {
                id: 2,
                name: 'Flexibility and Easy customization',
                text: [
                    `We understood that the web resource would have to be adapted according to the client’s needs, which means the technology used should be customizable. And Spree Commerce set of features ensures such a result. The project implemented on the Spree Commerce basis has a modifiable and flexible structure, therefore, it's open to the development of new extensions and can be easily customized to meet unique client's preferences.`,
                ]
            },
            {
                id: 3,
                name: 'Scalability',
                text: [
                    `Many online stores faced a problem at the stage of business growth because the web platform couldn't keep up with their evolvement. We wanted to guarantee our client would avoid such a fate. Fortunately, Spree Commerce is highly scalable and perfect for creating big online stores intended to expand the product base and increase the number of customers.`,
                ]
            },
            {
                id: 4,
                name: 'Third-party Solutions Integration',
                text: [
                    `When you create a fashion brand e-commerce website, you often face the necessity to connect various external modules. In particular, an online store is unthinkable without a reliable payment system. Working with Spree Commerce, you can be sure you'll be able to easily connect any payment gateway. This technology seamlessly integrates PayU, Stripe, Paypal and other similar third-party solutions.`,
                ]
            },
        ]
    },
    ProductSection: {
        title: 'Product page',
        subtitle: 'A product page is a more important feature than it might seem at first glance. Its task is to present a specific item in the best light. YEAH coped with the task perfectly.',
        image: '/yeah-images/product.png',
        alt: '',
        items: [
            {
                icon: '/yeah-images/icons/edit.png',
                title: 'Good visualization',
                subtitle: 'A couple of pictures from different angles allow the buyer to evaluate a particular product before the purchase.',
                width: 32,
                height: 32,
            },
            {
                icon: '/yeah-images/icons/text.png',
                title: 'Detailed description',
                subtitle: 'the consumer’ll find out all the necessary information about each item, including the fabric composition.',
                width: 32,
                height: 32,
            },
            {
                icon: '/yeah-images/icons/face.png',
                title: 'Useful information',
                subtitle: 'YEAH explains your delivery options and tells you how to choose the right size of underwear.',
                width: 32,
                height: 32,
            },
        ]
    },
    FilterSection: {
        title: 'A simple filter system',
        subtitle: 'We were assigned to build a responsive e-commerce store in a minimalist style. This concept extends to all aspects: restrained color palette, clear UI/UX, maximum ergonomics.',
        image: '/yeah-images/filter.png',
        alt: '',
    },
    ShoppingBagSection: {
        title: 'Shopping bag and payment',
        subtitle: `The shopping bag is rather non-standard: being located on the right side of the screen, it takes up only a small part of the page. Thus, a user doesn't lose sight of the product card and can easily continue shopping. In addition, the page looks very modern and stylish.`,
        image: '/yeah-images/shopping-bag.png',
        alt: ''
    }
}

export function isLastIndex(index: number, arrayLength: number) {
    return index === arrayLength - 1;
}